var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#2a72ff","strokeWidth":"1.5"},[React.createElement("path",{"d":"m16 8.5v6.28a1.22 1.22 0 0 1 -1.22 1.22h-12.56a1.22 1.22 0 0 1 -1.22-1.22v-12.56a1.22 1.22 0 0 1 1.22-1.22h6.28","strokeLinejoin":"round","key":0}),React.createElement("g",{"strokeMiterlimit":"10","key":1},[React.createElement("path",{"d":"m5.5 11.5 10.5-10.5","key":0}),React.createElement("path",{"d":"m16 7v-6h-6","key":1})])]));
}

ExternalLink.defaultProps = {"className":"external-link","height":"17","viewBox":"0 0 17 17","width":"17"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
